import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, share } from 'rxjs';
import { getQueryParams } from '@hglobal/common';
import { environment } from '@pt/environment';

import { GetMetricsReq, GetMetricsRes, GetTransactionsReq, GetTransactionsRes } from '../models';
import { TransactionsApi } from './transactions-api.interface';

@Injectable()
export class TransactionsApiService implements TransactionsApi {
  readonly #httpClient = inject(HttpClient);

  getMetrics(params: GetMetricsReq): Observable<GetMetricsRes> {
    const apiUrl = environment.apiHost + (params.forTeam
      ? 'team-reward/transaction-metrics/'
      : 'banking/transaction-metrics/');
    return this.#httpClient.get<GetMetricsRes>(apiUrl).pipe(share());
  }

  getTransactions(params: GetTransactionsReq): Observable<GetTransactionsRes> {
    const apiUrl = environment.apiHost
      + (params.forTeam
        ? params.userId
          ? params.myTeam
            ? `team-reward/my-team/user-team-bonus-histories/${params.userId}/`
            : `team-reward/admin/user-team-bonus-histories/${params.userId}/`
          : 'team-reward/history/'
        : params.userId
          ? params.myTeam
            ? `banking/my-team/${params.userId}/transactions/`
            : `banking/${params.userId}/transactions/`
          : 'banking/transactions/');

    return this.#httpClient.get<GetTransactionsRes>(apiUrl, {
      params: getQueryParams(params.filters),
    }).pipe(share());
  }
}
